import React from 'react';

export interface ResponseDockMarkProps {
  size?: number;
  className?: string;
  title?: string;
  /** Optional CSS colour (including currentColor) for white-label hosts. */
  color?: string;
  bubbleColor?: string;
}

export function ResponseDockMark({ size = 28, className, title, color, bubbleColor = 'white' }: ResponseDockMarkProps) {
  const id = React.useId().replace(/:/g, '');
  const gradientId = `rd-mark-gradient-${id}`;
  const titleId = `rd-mark-title-${id}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : 'true'}
      aria-labelledby={title ? titleId : undefined}
      focusable="false"
      shapeRendering="geometricPrecision"
      className={className}
      style={{ flexShrink: 0, display: 'block' }}
    >
      {title && <title id={titleId}>{title}</title>}
      <defs>
        <linearGradient id={gradientId} x1="12" y1="8" x2="116" y2="120" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#E649A9" />
          <stop offset="1" stopColor="#A21CAF" />
        </linearGradient>
      </defs>
      <rect width="128" height="128" rx="30" fill={color ?? `url(#${gradientId})`} />
      <path
        d="M20 34.5L28.5 43L43 27.5M57 36H108M30 66H30.1M57 66H108M30 96H30.1M57 96H108"
        stroke={bubbleColor}
        strokeWidth="9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
